if (typeof QuickViewProduct !== "function") {
  class QuickViewProduct extends HTMLElement {
    constructor() {
      super();
      this.init();
    }
    init() {
      this.quickViewModal = null;
      this.attachEventListeners();
    }
    attachEventListeners() {
      this.addEventListener("click", (evt) => {
        if (!this.classList.contains("quick-view-initialized")) {
          this.classList.add("quick-view-initialized");
        }
        
        // Check if the click originated from elements that should not trigger the modal
        const ignoreElements = ["button", "input"]; // Elements like buttons and inputs

        if (ignoreElements.includes(evt.target.tagName.toLowerCase())) {
          if (evt.target.classList.contains("add-to-cart")) {
            // delay site-cart-sidebar show
            setTimeout(function () {
              document.getElementById("site-cart-sidebar").show();
            }, 500);
            return; // Allow add to cart button to function normally
          }
          // Handle other elements if needed
          evt.preventDefault(); // Prevent default for other elements
          return;
        }

        evt.preventDefault();
        const url = this.getAttribute("data-url");
        this.showQuickViewModal(url, this);
      });

      // Listen for changes in the quantity input
      document
        .querySelectorAll(".quick-add-to-cart_quantity")
        .forEach((element) => {
          element.addEventListener("click", (e) => {
            e.stopPropagation(); // Prevent event from bubbling up to parent elements
          });
        });
    }

    showQuickViewModal(url, item) {
      const modalId = `modal-${new Date().getTime()}`;
      const existingModal = document.getElementById(modalId);

      if (existingModal) {
        existingModal.show();
        return;
      }

      item.classList.add("working");
      fetch(`${url}${url.includes("?") ? "&" : "?"}view=quick-view`)
        .then((response) => response.text())
        .then((text) => {
          const quickViewHTML = new DOMParser()
            .parseFromString(text, "text/html")
            .querySelector("#product-quick-view");
          const quickViewContainer = document.createElement("div");
          quickViewContainer.innerHTML = `<modal-box id="${modalId}"  
              class="modal modal--product" 
              data-options='{
                "enabled": false,
                "showOnce": false,
                "blockTabNavigation": true
              }'
              tabindex="-1" role="dialog" aria-modal="true">
              <div class="container--medium">
                <div class="modal-content">
                  <button class="modal-close" data-js-close data-js-first-focus style="position:absolute;margin:0;top:0;right:0">${window.KROWN.settings.symbols.close}</button>
                </div>
              </div>
              <span class="modal-background" data-js-close></span>
            </modal-box>`;

          const modal = quickViewContainer.querySelector("modal-box");
          document.body.appendChild(modal);
          modal.querySelector(".modal-content").innerHTML =
            quickViewHTML.innerHTML;

          if (!window.productPageScripts) {
            const scripts = modal.querySelectorAll("script");
            scripts.forEach((elm) => {
              const script = document.createElement("script");
              script.src = elm.src;
              document.body.append(script);
              window.productPageScripts = true;
            });
          }

          modal
            .querySelector(".product-quick-view__close")
            .addEventListener("click", () => {
              modal.hide();
            });

          if (modal.querySelector("[data-js-product-form]")) {
            modal
              .querySelector("[data-js-product-form]")
              .addEventListener("add-to-cart", () => {
                modal.hide();
              });
          }

          setTimeout(() => {
            modal.show();
            item.classList.remove("working");
          }, 250);
        });
    }
  }

  if (typeof customElements.get("quick-view-product") === "undefined") {
    customElements.define("quick-view-product", QuickViewProduct);
  }
}